export const NIGHTS_FETCH_AND_SET_EXTRAS = "NIGHTS_FETCH_AND_SET_EXTRAS";
export const NIGHTS_FETCH_AND_SET_INITIAL_DATA = 'NIGHTS_FETCH_AND_SET_INITIAL_DATA';
export const NIGHTS_FETCH_ORIGINS_WITH_DESTINATIONS = "NIGHTS_FETCH_ORIGINS_WITH_DESTINATIONS";
export const NIGHTS_FETCH_AND_SET_FLIGHTS = "NIGHTS_FETCH_AND_SET_FLIGHTS";
export const NIGHTS_FETCH_AND_SET_HOTELS = "NIGHTS_FETCH_AND_SET_HOTELS";
export const NIGHTS_RECHECK_HOTEL_AND_SET_FINAL_PRICE = "NIGHTS_RECHECK_HOTEL_AND_SET_FINAL_PRICE";
export const NIGHTS_SET_DATA_FROM_QUERY_PARAMS = 'NIGHTS_SET_DATA_FROM_QUERY_PARAMS';
export const NIGHTS_SET_INITIAL_DATA = "NIGHTS_SET_INITIAL_DATA";
export const NIGHTS_SET_DESTINATIONS_WITH_FLIGHTS = "NIGHTS_SET_DESTINATIONS_WITH_FLIGHTS";
export const FETCH_INTERCONTINENTAL_FLIGHTS = "FETCH_INTERCONTINENTAL_FLIGHTS";
export const SET_JOURNEY_FLIGHT = "SET_JOURNEY_FLIGHT";
export const SET_RETURN_FLIGHT = "SET_RETURN_FLIGHT";
export const FETCH_DESTINATION_CARDS = "FETCH_DESTINATION_CARDS";

